import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'antd';
import { cloneDeep, flatten } from 'lodash';

import { getEmailTypeList } from 'Root/http';

import NotificationSettingItem from './NotificationSettingItem';

import s from './NotificationSettings.pcss';


function getDifference(originalSettings, settings) {
  const added = Object.keys(settings)
    .filter(key => settings[key] > (originalSettings[key] || 0));
  const deleted = Object.keys(originalSettings)
    .filter(key => !settings[key] && originalSettings[key] > 0);
  return {
    added,
    deleted,
  };
}

function getSettingsByType(settings, intersections, type) {
  const obj = {};
  const property = type === 'lock' ? 'lockedEmailTypeArray' : 'usedEmailTypeArray';
  const stateSettings = flatten(intersections.map(int => (int[property] ? int[property].split(',') : [])));

  settings.forEach((setting) => {
    obj[setting.id] = stateSettings.filter(st => st === setting.id).length;
  });

  return obj;
}

export default class NotificationSettings extends React.Component {
  static propTypes = {
    intersectionsType: PropTypes.string,
    intersections: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    onSave: PropTypes.func.isRequired,
  };

  static defaultProps = {
    intersectionsType: 'user',
  };


  constructor(props) {
    super(props);
    const { intersections } = this.props;

    this.state = {
      settings: [],
      lockedSettings: getSettingsByType([], intersections, 'lock'),
      usedSettings: getSettingsByType([], intersections),
    };
  }

  componentDidMount() {
    getEmailTypeList().then((settings) => {
      this.setState({ settings });
    });
  }

  componentWillReceiveProps(nextProps) {
    if ((nextProps.intersections.length !== this.props.intersections.length) ||
      (nextProps.intersections.length !== this.props.intersections.length)
    ) {
      this.setState({
        lockedSettings: getSettingsByType(this.state.settings, nextProps.intersections, 'lock'),
        usedSettings: getSettingsByType(this.state.settings, nextProps.intersections),
      });
    }
  }

  handleChangeSetting = key => (value, type) => {
    const { intersections } = this.props;
    const { usedSettings, lockedSettings } = cloneDeep(this.state);

    if (type === 'lock') {
      if (value) {
        lockedSettings[key] = intersections.length;
      } else {
        delete lockedSettings[key];
      }
    } else if (value) {
      usedSettings[key] = intersections.length;
    } else {
      delete usedSettings[key];
    }

    this.setState({ usedSettings, lockedSettings });
  };

  isAllSelected = (key, type) => {
    const { usedSettings, lockedSettings } = this.state;
    const { intersections } = this.props;
    const settings = type === 'lock' ? lockedSettings : usedSettings;
    if (!settings[key]) return 'no';
    if (settings[key] === intersections.length) return 'yes';
    return 'indeterminate';
  };

  hasDifference = () => {
    const diff = this.getDifference();
    return diff.usedDiff.added.length + diff.usedDiff.deleted.length +
      diff.lockedDiff.deleted.length + diff.lockedDiff.added.length > 0;
  };

  getDifference = () => {
    const { usedSettings, lockedSettings, settings } = this.state;
    const { intersections } = this.props;

    const lockedOriginalSettings = getSettingsByType(settings, intersections, 'lock');
    const usedOriginalSettings = getSettingsByType(settings, intersections);
    const usedDiff = getDifference(usedOriginalSettings, usedSettings);
    const lockedDiff = getDifference(lockedOriginalSettings, lockedSettings);

    return { usedDiff, lockedDiff };
  };

  onSave = () => {
    const { intersectionsType } = this.props;

    const fieldName = intersectionsType === 'users' ? 'userArray' : 'groupIds';
    const joinedList = intersectionsType === 'users' ?
      this.props.intersections.map(int => int.userId.id).join(',') :
      this.props.intersections.map(int => int.id).join(',');

    const diff = this.getDifference();
    const data = {
      [fieldName]: joinedList,
      addEmailTypeArray: diff.usedDiff.added.length > 0 ? diff.usedDiff.added.join(',') : undefined,
      deleteEmailTypeArray: diff.usedDiff.deleted.length > 0 ? diff.usedDiff.deleted.join(',') : undefined,
      lockEmailTypeArray: diff.lockedDiff.added.length > 0 ? diff.lockedDiff.added.join(',') : undefined,
      unlockEmailTypeArray: diff.lockedDiff.deleted.length > 0 ? diff.lockedDiff.deleted.join(',') : undefined,
    };

    this.props.onSave(data);
  };

  onCancel = () => {
    const { settings } = this.state;
    const { intersections } = this.props;
    this.setState({
      lockedSettings: getSettingsByType(settings, intersections, 'lock'),
      usedSettings: getSettingsByType(settings, intersections),
    });
  };

  render() {
    const { settings } = this.state;
    const { intersections } = this.props;

    const needSave = this.hasDifference();

    return (
      <div className={s.container}>
        <div className={s.controls}>
          {needSave ? (
            <React.Fragment>
              <Button className={s.cancelBtn} onClick={this.onCancel}>
                Вернуть
              </Button>
              <Button type="primary" className={s.successBtn} onClick={this.onSave}>
                Применить
              </Button>
            </React.Fragment>
          ) : null}
        </div>

        <div className={s.label}>Настройки Email уведомлений</div>

        <div className={s.settingList}>
          {settings.map((setting) => {
            const allUsersHasNotification = this.isAllSelected(setting.id);
            const allLockedHasNotification = this.isAllSelected(setting.id, 'lock');
            return (
              <NotificationSettingItem
                key={setting.id}
                disabled={!intersections.length}
                setting={setting}
                allUsersHasNotification={allUsersHasNotification}
                allLockedHasNotification={allLockedHasNotification}
                onChangeSetting={this.handleChangeSetting(setting.id)}
              />
            );
          })}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Notifications/NotificationSettings/NotificationSettings.js